import { render, staticRenderFns } from "./QuantitativeAssessment.vue?vue&type=template&id=5b166bd1&scoped=true&"
import script from "./QuantitativeAssessment.vue?vue&type=script&lang=js&"
export * from "./QuantitativeAssessment.vue?vue&type=script&lang=js&"
import style0 from "./QuantitativeAssessment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./QuantitativeAssessment.vue?vue&type=style&index=1&id=5b166bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b166bd1",
  null
  
)

export default component.exports